import React from 'react';
import { CardTitle } from './Card';

export default class SongList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleOpen = this.handleOpen.bind(this);
  }

  handleOpen(e, filename) {
    e.preventDefault();
    this.props.onSelect(filename);
  }

  render() {
    return (
      <div className="card mb-3 paper-shadow">
        <div className="card-body pb-0">
          <CardTitle title="Open a Song" />
        </div>
        <div className="list-group list-group-flush">
          {this.props.songlist.map((filename, idx) => (
            <a
              key={idx}
              href="#open-file"
              className="list-group-item list-group-item-action flex-column align-items-start"
              onClick={e => this.handleOpen(e, filename)}
            >
              <div className="d-flex w-100 justify-content-between">
                <div>{filename}</div>
                {/* <small>3 days ago</small> */}
              </div>
              {/*
              <p className="mb-1">
                Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus
                varius blandit.
              </p>
              <small>Donec id elit non mi porta.</small>
              */}
            </a>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SongList.js